import { render } from "./ProfilPage.vue?vue&type=template&id=7bd9271b"
import script from "./ProfilPage.vue?vue&type=script&lang=js"
export * from "./ProfilPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__